<div class="splash-screen">
  <div class="splash-loader-container">
    <!-- splash window -->
    <div class="bg_color_gray">
      <img id="splash" src="assets/images/caloudi/caloudi_logo_splash.gif" alt="splash" />
    </div>
  </div>
</div>
